import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ message = "Loading venues..." }) => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#fef3c7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div style={{
          position: 'relative',
          marginBottom: '32px'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            border: '4px solid #fcd34d',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <div style={{
            width: '64px',
            height: '64px',
            border: '4px solid #f59e0b',
            borderTop: '4px solid transparent',
            borderRadius: '50%',
            position: 'absolute',
            top: 0,
            left: 0,
            animation: 'spin 1s linear infinite'
          }}></div>
        </div>
        
        <motion.p
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          style={{
            color: '#6b7280',
            fontWeight: '500',
            fontSize: '16px',
            margin: 0
          }}
        >
          {message}
        </motion.p>
      </motion.div>
      
      {/* CSS Animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;
